export default __webpack_public_path__ + "static/media/photo3.455b8224.jpg";